import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import themeColors from '../../assets/styles/themeColors';
import { Heading } from '../../components/Heading';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import OnBoardingCta from '../../components/OnBoarding/OnBoardingCta';
import Paragraph from '../../components/Paragraph/Paragraph';
import { useMenu } from '../../hooks/useMenu';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import { zaiusSubscribe } from '../../zaiusSubscribe';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { ACCOUNT_STEP_COMPLETE, ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';

const MetalStream = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { BrokerName } = useSelector(selectSettings);
  const { gtmStepEvent } = useGtmStepHook();

  useEffect(() => {
    zaiusSubscribe();
  }, []);

  useEffect(() => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel: 'MetalStream main page',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGtmEvent = () => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'MetalStream main page',
    });
  };

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('metalstream.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={12}>{t('metalstream.welcomeTitle')}</Heading>
      <Paragraph color={themeColors.colorTextXLLight}>
        1. {t('metalstream.welcomePointOne')}
      </Paragraph>
      <Paragraph color={themeColors.colorTextXLLight}>
        2. {t('metalstream.welcomePointTwo')}
      </Paragraph>
      <Paragraph color={themeColors.colorTextXLLight}>
        3. {t('metalstream.welcomePointThree')}
      </Paragraph>
      <OnBoardingCta
        onClick={() => {
          history.push(activeItem?.nextPath);
          handleGtmEvent();
        }}
      />
    </OnBoardingContainer>
  );
};

export default MetalStream;
